const CURRENT_ORG_STORE_KEY = 'currentOrg';

export const deleteCurrentOrg = (): void => {
  localStorage.removeItem(CURRENT_ORG_STORE_KEY);
};

export const storeCurrentOrg = (orgID: string): void => {
  localStorage.setItem(CURRENT_ORG_STORE_KEY, orgID);
};

export const getCurrentOrg = (): string | null => {
  const orgID = localStorage.getItem(CURRENT_ORG_STORE_KEY);
  return orgID;
};
